export default function json(value: any, ...args: any) {
  if (typeof value === "object") {
    return JSON.stringify(value, args[0], args[1]);
  } else {
    return JSON.parse(value, args[0]);
  }
}
